import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { useTranslation } from "@redotech/redo-i18n";
import ActivityHeartIcon from "@redotech/redo-icons/activity-heart.svg";
import ActivityHeartFilledIcon from "@redotech/redo-icons/activity-heart_filled.svg";
import Award01Icon from "@redotech/redo-icons/award-01.svg";
import Award01FilledIcon from "@redotech/redo-icons/award-01_filled.svg";
import BarChart01Icon from "@redotech/redo-icons/bar-chart-01.svg";
import BarChart01FilledIcon from "@redotech/redo-icons/bar-chart-01_filled.svg";
import Bell03Icon from "@redotech/redo-icons/bell-03.svg";
import Bell03FilledIcon from "@redotech/redo-icons/bell-03_filled.svg";
import Brush01Icon from "@redotech/redo-icons/brush-01.svg";
import Brush01FilledIcon from "@redotech/redo-icons/brush-01_filled.svg";
import CodeBrowserIcon from "@redotech/redo-icons/code-browser.svg";
import CodeBrowserFilledIcon from "@redotech/redo-icons/code-browser_filled.svg";
import CoinsStacked03Icon from "@redotech/redo-icons/coins-stacked-03.svg";
import CoinsStacked03FilledIcon from "@redotech/redo-icons/coins-stacked-03_filled.svg";
import CreditCard01Icon from "@redotech/redo-icons/credit-card-01.svg";
import CreditCard01FilledIcon from "@redotech/redo-icons/credit-card-01_filled.svg";
import FileCheck02Icon from "@redotech/redo-icons/file-check-02.svg";
import FileCheck02FilledIcon from "@redotech/redo-icons/file-check-02_filled.svg";
import FilterLinesIcon from "@redotech/redo-icons/filter-lines.svg";
import FilterLinesFilledIcon from "@redotech/redo-icons/filter-lines_filled.svg";
import FlipBackwardIcon from "@redotech/redo-icons/flip-backward.svg";
import FlipBackwardFilledIcon from "@redotech/redo-icons/flip-backward_filled.svg";
import Home02Icon from "@redotech/redo-icons/home-02.svg";
import Home02FilledIcon from "@redotech/redo-icons/home-02_filled.svg";
import Inbox01Icon from "@redotech/redo-icons/inbox-01.svg";
import Inbox01FilledIcon from "@redotech/redo-icons/inbox-01_filled.svg";
import LayersThree02Icon from "@redotech/redo-icons/layers-three-02.svg";
import LayersThree02FilledIcon from "@redotech/redo-icons/layers-three-02_filled.svg";
import LayoutGrid01Icon from "@redotech/redo-icons/layout-grid-01.svg";
import LayoutGrid01FilledIcon from "@redotech/redo-icons/layout-grid-01_filled.svg";
import Mail01Icon from "@redotech/redo-icons/mail-01.svg";
import Mail01FilledIcon from "@redotech/redo-icons/mail-01_filled.svg";
import MessageChatCircleIcon from "@redotech/redo-icons/message-chat-circle.svg";
import MessageChatCircleFilledIcon from "@redotech/redo-icons/message-chat-circle_filled.svg";
import MessageSquare01Icon from "@redotech/redo-icons/message-square-01.svg";
import MessageSquare01FilledIcon from "@redotech/redo-icons/message-square-01_filled.svg";
import PackageIcon from "@redotech/redo-icons/package.svg";
import PackageFilledIcon from "@redotech/redo-icons/package_filled.svg";
import Pencil01Icon from "@redotech/redo-icons/pencil-01.svg";
import Pencil01FilledIcon from "@redotech/redo-icons/pencil-01_filled.svg";
import Phone01Icon from "@redotech/redo-icons/phone-01.svg";
import Phone01FilledIcon from "@redotech/redo-icons/phone-01_filled.svg";
import RefreshCw01Icon from "@redotech/redo-icons/refresh-cw-01.svg";
import RefreshCw01FilledIcon from "@redotech/redo-icons/refresh-cw-01_filled.svg";
import Route01Icon from "@redotech/redo-icons/route.svg";
import Route01FilledIcon from "@redotech/redo-icons/route_filled.svg";
import Settings02Icon from "@redotech/redo-icons/settings-02.svg";
import Settings02FilledIcon from "@redotech/redo-icons/settings-02_filled.svg";
import Share07Icon from "@redotech/redo-icons/share-07.svg";
import Share07FilledIcon from "@redotech/redo-icons/share-07_filled.svg";
import ShieldDollarIcon from "@redotech/redo-icons/shield-dollar.svg";
import ShieldDollarFilledIcon from "@redotech/redo-icons/shield-dollar_filled.svg";
import ShieldTickIcon from "@redotech/redo-icons/shield-tick.svg";
import ShieldTickFilledIcon from "@redotech/redo-icons/shield-tick_filled.svg";
import ShoppingBag01Icon from "@redotech/redo-icons/shopping-bag-01.svg";
import ShoppingBag01FilledIcon from "@redotech/redo-icons/shopping-bag-01_filled.svg";
import ShoppingCart03Icon from "@redotech/redo-icons/shopping-cart-03.svg";
import ShoppingCart03FilledIcon from "@redotech/redo-icons/shopping-cart-03_filled.svg";
import Stars01Icon from "@redotech/redo-icons/stars-01.svg";
import Stars01FilledIcon from "@redotech/redo-icons/stars-01_filled.svg";
import Tag01Icon from "@redotech/redo-icons/tag-01.svg";
import Tag01FilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import Target01Icon from "@redotech/redo-icons/target-01.svg";
import Target01FilledIcon from "@redotech/redo-icons/target-01_filled.svg";
import Truck01Icon from "@redotech/redo-icons/truck-01.svg";
import Truck01FilledIcon from "@redotech/redo-icons/truck-01_filled.svg";
import UserEditIcon from "@redotech/redo-icons/user-edit.svg";
import UserEditFilledIcon from "@redotech/redo-icons/user-edit_filled.svg";
import Users01Icon from "@redotech/redo-icons/users-01.svg";
import Users01FilledIcon from "@redotech/redo-icons/users-01_filled.svg";
import UsersPlusIcon from "@redotech/redo-icons/users-plus.svg";
import UsersPlusFilledIcon from "@redotech/redo-icons/users-plus_filled.svg";
import XCircleIcon from "@redotech/redo-icons/x-circle.svg";
import XCircleFilledIcon from "@redotech/redo-icons/x-circle_filled.svg";
import ZapIcon from "@redotech/redo-icons/zap.svg";
import ZapFilledIcon from "@redotech/redo-icons/zap_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import {
  type SettingsVisibility,
  useSettingsVisibility,
} from "@redotech/redo-merchant-app-common/settings/use-settings-visibility";
import {
  NotificationTab,
  notificationTabToFriendly,
} from "@redotech/redo-merchant-general-app/setting/notification/notification-tabs";
import { RETURNS_SETTINGS_TAB_QUERY_PARAM } from "@redotech/redo-settings-common/flat-team-settings/returns/returns-settings-tab";
import { RETURNS_CONSOLIDATED_SETTINGS_PATH } from "@redotech/redo-settings-common/flat-team-settings/returns/settings-paths";
import {
  SettingItemSearchTab,
  SettingsSection,
  SettingsSectionEnum,
} from "@redotech/redo-web/navigation/redo-settings-nav";
import { getSettingsTabHref } from "@redotech/redo-web/settings-search/settings-search";
import { filterTruthy } from "@redotech/util/array";
import {
  GENERAL_AI_TAB_QUERY,
  GeneralAiTab,
  generalAiTabToFriendly,
} from "../../../setting/ai-agent/general-tabs";
import {
  CUSTOMER_WIDGET_TAB_QUERY,
  CustomerWidgetTab,
  customerWidgetTabToFriendly,
} from "../../../setting/customer-widget/customer-widget-tabs";
import { useReturnsSettingsTabs } from "../../../setting/returns/returns-settings-tabs";
import { navPage, settingsSection, visibleNavPages } from "./settings-section";
import {
  useFulfillmentSettings,
  useShippingSettings,
  withNewGeneralSearchTerms,
} from "./settings.new";

export function useSettingsItems(): SettingsSection[] | null {
  const catalogSearch = useLoad(
    () => import("./settings-navigation-search"),
    [],
  );
  const visibility = useSettingsVisibility();
  const routes = useRequiredContext(MerchantRoutesContext);
  const generalSettings = withNewGeneralSearchTerms(
    useGeneralSettings(visibility),
  );
  const personalSettings = usePersonalSettings(visibility);
  const aiSettings = useAiSettings(visibility);
  // const catalogSettings = useCatalogSettings();
  const conversionSettings = useConversionSettings(visibility);
  const paymentsSettings = usePaymentsSettings(visibility);
  const chargebacksSettings = useChargebacksSettings(visibility);
  const customersSettings = useCustomersSettings(visibility);
  const inventoryManagementSettings =
    useInventoryManagementSettings(visibility);
  const marketingSettings = useMarketingSettings(visibility);
  const orderTrackingSettings = useOrderTrackingSettings(visibility);
  const productsSettings = useProductsSettings(visibility);
  const returnsSettings = useReturnsSettings(visibility);
  const warrantiesSettings = useWarrantiesSettings(visibility);
  const fulfillmentSettings = useFulfillmentSettings(visibility);
  const shippingSettings = useShippingSettings(visibility);
  const internationalSettings = useInternationalSettings(visibility);
  const supportSettings = useSupportSettings(visibility);
  const suppliesSettings = useSuppliesSettings(visibility);

  const allSettingsItems: SettingsSection[] = filterTruthy([
    generalSettings,
    aiSettings,
    // catalogSettings,
    conversionSettings,
    paymentsSettings,
    chargebacksSettings,
    customersSettings,
    fulfillmentSettings,
    inventoryManagementSettings,
    suppliesSettings,
    marketingSettings,
    orderTrackingSettings,
    personalSettings,
    productsSettings,
    returnsSettings,
    shippingSettings,
    internationalSettings,
    supportSettings,
    warrantiesSettings,
  ]);

  if (!catalogSearch.value) {
    return allSettingsItems;
  }
  return catalogSearch.value.addSettingsCatalogSearchTerms({
    routes,
    sections: allSettingsItems,
    viewerVisibility: "merchant",
  });
}

function useAiSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(visibility, "ai", SettingsSectionEnum.AI, [
    navPage("ai/general", {
      id: "ai-general",
      href: routes.getSettingsSubRoute("ai/general"),
      friendlyName: t("General", {
        context: "merchant settings label for general AI configuration",
      }),
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
      searchTabs: Object.values(GeneralAiTab).map((tab) => ({
        href: getSettingsTabHref({
          href: routes.getSettingsSubRoute("ai/general"),
          param: GENERAL_AI_TAB_QUERY,
          tab,
        }),
        id: tab,
        label: generalAiTabToFriendly(tab),
      })),
    }),
    navPage("ai/knowledge", {
      id: "ai-knowledge",
      href: routes.getSettingsSubRoute("ai/knowledge"),
      friendlyName: t("Knowledge", {
        context: "merchant settings label for AI knowledge sources",
      }),
      UnfilledIcon: Stars01Icon,
      FilledIcon: Stars01FilledIcon,
    }),
    navPage("ai/skills", {
      id: "ai-skills",
      href: routes.getSettingsSubRoute("ai/skills"),
      friendlyName: t("Skills", {
        context: "merchant settings label for AI agent skills",
      }),
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    }),
  ]);
}

function useChargebacksSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(
    visibility,
    "chargebacks",
    SettingsSectionEnum.CHARGEBACKS,
    [
      navPage("chargebacks/chargebacks", {
        id: "chargebacks",
        href: routes.getSettingsSubRoute("chargebacks"),
        friendlyName: t("Chargebacks", {
          context: "merchant settings label for chargebacks configuration",
        }),
        UnfilledIcon: ShieldDollarIcon,
        FilledIcon: ShieldDollarFilledIcon,
      }),
    ],
  );
}

function useConversionSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const section = settingsSection(
    visibility,
    "conversion",
    SettingsSectionEnum.CONVERSION,
    [
      navPage("conversion/general", {
        id: "general",
        href: routes.getSettingsSubRoute("conversion/general"),
        friendlyName: t("Conversion", {
          context:
            "merchant settings label for checkout conversion configuration",
        }),
        UnfilledIcon: ShoppingCart03Icon,
        FilledIcon: ShoppingCart03FilledIcon,
      }),
    ],
  );
  section?.items.sort((a, b) => {
    // sort by friendlyName but make sure "General" is at the top
    if (a.id === "general") {
      return -1;
    }
    if (b.id === "general") {
      return 1;
    }
    return a.friendlyName.localeCompare(b.friendlyName);
  });
  return section;
}

function usePaymentsSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(visibility, "payments", SettingsSectionEnum.PAYMENTS, [
    navPage("payments/hsa", {
      id: "hsa",
      href: routes.getSettingsSubRoute("payments/hsa"),
      friendlyName: t("HSA/FSA"),
      UnfilledIcon: ActivityHeartIcon,
      FilledIcon: ActivityHeartFilledIcon,
    }),
  ]);
}

function useCustomersSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(
    visibility,
    "customer-accounts",
    SettingsSectionEnum.CUSTOMER_ACCOUNTS,
    [
      navPage("customer-accounts/ad-blocks", {
        id: "customer-accounts-ad-blocks",
        href: routes.getSettingsSubRoute("customer-accounts-ad-blocks"),
        friendlyName: t("Ad blocks", {
          context:
            "merchant settings label for customer account advertisements",
        }),
        UnfilledIcon: Target01Icon,
        FilledIcon: Target01FilledIcon,
      }),
      navPage("customer-accounts/storefront-display", {
        id: "customer-accounts-storefront-display",
        href: routes.getSettingsSubRoute(
          "customer-accounts-storefront-display",
        ),
        friendlyName: t("Storefront display", {
          context:
            "merchant settings label for customer account storefront displays",
        }),
        UnfilledIcon: LayoutGrid01Icon,
        FilledIcon: LayoutGrid01FilledIcon,
      }),
    ],
  );
}

function useSuppliesSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(visibility, "supplies", SettingsSectionEnum.SUPPLIES, [
    navPage("supplies/shipping-rules", {
      id: "supplies-shipping-rules",
      href: routes.getSettingsSubRoute("supplies/shipping-rules"),
      friendlyName: t("Shipping rules", {
        context: "merchant settings label for supplies shipping rules",
      }),
      UnfilledIcon: Truck01Icon,
      FilledIcon: Truck01FilledIcon,
    }),
  ]);
}

function useInventoryManagementSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(
    visibility,
    "inventory-management",
    SettingsSectionEnum.INVENTORY_MANAGEMENT,
    [
      navPage("inventory-management/inventory-management", {
        id: "inventory-management",
        href: routes.getSettingsSubRoute("inventory-management"),
        friendlyName: t("Inventory management", { context: "settings nav" }),
        searchTerms: [
          "general",
          "purchase orders",
          "sales channels",
          "inventory push",
          "import inventory",
          "accounting",
          "QuickBooks",
        ],
        UnfilledIcon: PackageIcon,
        FilledIcon: PackageFilledIcon,
      }),
    ],
  );
}

function usePersonalSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(visibility, "personal", SettingsSectionEnum.PERSONAL, [
    navPage("personal/profile", {
      id: "personal-profile",
      href: routes.getSettingsSubRoute("personal"),
      friendlyName: t("Profile", {
        context: "merchant settings label for the current user's profile",
      }),
      UnfilledIcon: UserEditIcon,
      FilledIcon: UserEditFilledIcon,
    }),
  ]);
}

function useGeneralSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(visibility, "general", SettingsSectionEnum.GENERAL, [
    navPage("general/billing", {
      id: "billing-button",
      href: routes.getSettingsSubRoute("billing"),
      friendlyName: t("Billing", {
        context: "merchant settings label for billing",
      }),
      UnfilledIcon: CreditCard01Icon,
      FilledIcon: CreditCard01FilledIcon,
      children: visibleNavPages(visibility, [
        navPage("general/billing-home", {
          id: "billing-home-button",
          href: routes.getSettingsSubRoute("billing"),
          friendlyName: t("Home", {
            context: "merchant settings label for the billing overview",
          }),
          UnfilledIcon: Home02Icon,
          FilledIcon: Home02FilledIcon,
        }),
        navPage("general/billing-activity", {
          id: "billing-activity-button",
          href: routes.getSettingsSubRoute("billing/reports"),
          friendlyName: t("Activity", {
            context: "merchant settings label for billing activity",
          }),
          UnfilledIcon: BarChart01Icon,
          FilledIcon: BarChart01FilledIcon,
        }),
        navPage("general/bills", {
          id: "bills-button",
          href: routes.getSettingsSubRoute("billing/bills"),
          friendlyName: t("Bills", {
            context: "merchant settings label for merchant bills",
          }),
          UnfilledIcon: CreditCard01Icon,
          FilledIcon: CreditCard01FilledIcon,
        }),
      ]),
    }),
    navPage("general/brand-kit", {
      id: "brand-kit-button",
      href: routes.getSettingsSubRoute("brand-kit"),
      friendlyName: t("Brand kit", {
        context: "merchant settings label for brand assets and styling",
      }),
      UnfilledIcon: Brush01Icon,
      FilledIcon: Brush01FilledIcon,
    }),
    navPage("general/communication", {
      id: "communication-button",
      href: routes.getSettingsSubRoute("communication"),
      friendlyName: t("Communication", {
        context: "merchant settings label for customer communication",
      }),
      UnfilledIcon: Mail01Icon,
      FilledIcon: Mail01FilledIcon,
    }),
    navPage("general/customer-widget", {
      id: "customer-widget-button",
      href: routes.getSettingsSubRoute("customer-widget"),
      friendlyName: t("Customer widget", {
        context: "merchant settings label for the customer widget",
      }),
      UnfilledIcon: MessageChatCircleIcon,
      FilledIcon: MessageChatCircleFilledIcon,
      searchTabs: getCustomerWidgetSearchTabs(
        routes.getSettingsSubRoute("customer-widget"),
      ),
    }),
    navPage("general/developer", {
      id: "developer-button",
      href: routes.getSettingsSubRoute("developer"),
      friendlyName: t("Developer", {
        context: "merchant settings label for developer tools",
      }),
      UnfilledIcon: CodeBrowserIcon,
      FilledIcon: CodeBrowserFilledIcon,
    }),
    navPage("general/integrations", {
      id: "general-integrations",
      href: routes.getSettingsSubRoute("integrations"),
      friendlyName: t("Integrations", {
        context: "merchant settings label for the integrations catalog",
      }),
      UnfilledIcon: Share07Icon,
      FilledIcon: Share07FilledIcon,
    }),
    navPage("general/notifications", {
      id: "notifications-button",
      href: routes.getSettingsSubRoute("notifications"),
      friendlyName: t("Notifications", {
        context: "merchant settings label for team notifications",
      }),
      UnfilledIcon: Bell03Icon,
      FilledIcon: Bell03FilledIcon,
      searchTabs: Object.values(NotificationTab).map((tab) => ({
        href: getSettingsTabHref({
          href: routes.getSettingsSubRoute("notifications"),
          tab,
        }),
        id: tab,
        label: notificationTabToFriendly(tab),
      })),
    }),
    navPage("general/roles", {
      id: "roles-button",
      href: routes.getSettingsSubRoute("roles"),
      friendlyName: t("Roles", {
        context: "merchant settings label for team roles",
      }),
      UnfilledIcon: ShieldTickIcon,
      FilledIcon: ShieldTickFilledIcon,
    }),
    navPage("general/users", {
      id: "users-button",
      href: routes.getSettingsSubRoute("users"),
      friendlyName: t("Users", {
        context: "merchant settings label for team users",
      }),
      UnfilledIcon: Users01Icon,
      FilledIcon: Users01FilledIcon,
    }),
    navPage("general/user-groups", {
      id: "user-groups-button",
      href: routes.getSettingsSubRoute("user-groups"),
      friendlyName: t("Groups", {
        context: "merchant settings label for team groups",
      }),
      UnfilledIcon: UsersPlusIcon,
      FilledIcon: UsersPlusFilledIcon,
    }),
  ]);
}

function useMarketingSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(
    visibility,
    "marketing",
    SettingsSectionEnum.MARKETING,
    [
      navPage("marketing/audience", {
        id: "audience",
        href: routes.getSettingsSubRoute("audience"),
        friendlyName: t("Audience", {
          context: "merchant settings label for marketing audiences",
        }),
        UnfilledIcon: Users01Icon,
        FilledIcon: Users01FilledIcon,
      }),
      navPage("marketing/email-domain", {
        id: "email-domain",
        href: routes.getSettingsSubRoute("email-domain"),
        friendlyName: t("Email domain", {
          context: "merchant settings label for the marketing email domain",
        }),
        UnfilledIcon: Mail01Icon,
        FilledIcon: Mail01FilledIcon,
      }),
      navPage("marketing/offer-page", {
        id: "offer-page-configuration",
        href: routes.getSettingsSubRoute("offer-page-configuration"),
        friendlyName: t("Offer page", {
          context: "merchant settings label for the marketing offer page",
        }),
        UnfilledIcon: CoinsStacked03Icon,
        FilledIcon: CoinsStacked03FilledIcon,
      }),
      navPage("marketing/sms", {
        id: "marketing-sms",
        href: routes.getSettingsSubRoute("sms-marketing"),
        friendlyName: t("SMS", {
          context: "merchant settings label for SMS marketing",
        }),
        UnfilledIcon: Phone01Icon,
        FilledIcon: Phone01FilledIcon,
      }),
      navPage("marketing/keywords", {
        id: "subscribe-keywords",
        href: routes.getSettingsSubRoute("subscribe-keywords"),
        friendlyName: t("Keywords", {
          context: "merchant settings label for SMS subscription keywords",
        }),
        UnfilledIcon: Tag01Icon,
        FilledIcon: Tag01FilledIcon,
      }),
      navPage("marketing/recover", {
        id: "recover-settings",
        href: routes.getSettingsSubRoute("recover-settings"),
        friendlyName: "Recover",
        UnfilledIcon: RefreshCw01Icon,
        FilledIcon: RefreshCw01FilledIcon,
      }),
      navPage("marketing/attribution", {
        id: "attribution",
        href: routes.getSettingsSubRoute("attribution"),
        friendlyName: t("Attribution", {
          context: "merchant settings label for marketing attribution",
        }),
        UnfilledIcon: BarChart01Icon,
        FilledIcon: BarChart01FilledIcon,
      }),
      navPage("marketing/marketing-agent", {
        id: "marketing-agent",
        href: routes.getSettingsSubRoute("marketing-agent"),
        friendlyName: t("{{productName}}", {
          productName: "Marketing Agent",
          context:
            "merchant settings label containing the official Marketing Agent product name",
        }),
        UnfilledIcon: Stars01Icon,
        FilledIcon: Stars01Icon,
      }),
    ],
  );
}

function useOrderTrackingSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(
    visibility,
    "order-tracking",
    SettingsSectionEnum.ORDER_TRACKING,
    [
      navPage("order-tracking/general", {
        id: "order-tracking-general",
        href: routes.getSettingsSubRoute("order-tracking"),
        friendlyName: t("General", {
          context:
            "merchant settings label for general order tracking configuration",
        }),
        UnfilledIcon: Settings02Icon,
        FilledIcon: Settings02FilledIcon,
      }),
    ],
  );
}

function useProductsSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(visibility, "products", SettingsSectionEnum.PRODUCTS, [
    navPage("products/attributes", {
      id: "attributes-button",
      href: routes.getSettingsSubRoute("attributes"),
      friendlyName: t("Attributes", {
        context: "merchant settings label for product attribute definitions",
      }),
      UnfilledIcon: LayersThree02Icon,
      FilledIcon: LayersThree02FilledIcon,
    }),
    navPage("products/products", {
      id: "products-button",
      href: routes.getSettingsSubRoute("products"),
      friendlyName: t("Products", {
        context: "merchant settings label for products",
      }),
      UnfilledIcon: ShoppingBag01Icon,
      FilledIcon: ShoppingBag01FilledIcon,
    }),
  ]);
}

function useReturnsSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const returnsSettingsTabs = useReturnsSettingsTabs();
  const returnsSettingsHref = routes.getSettingsSubRoute(
    RETURNS_CONSOLIDATED_SETTINGS_PATH,
  );
  return settingsSection(
    visibility,
    "returns-and-claims",
    SettingsSectionEnum.RETURNS_AND_CLAIMS,
    [
      navPage("returns-and-claims/returns", {
        id: "returns-consolidated",
        href: returnsSettingsHref,
        friendlyName: t("Returns"),
        UnfilledIcon: FlipBackwardIcon,
        FilledIcon: FlipBackwardFilledIcon,
        searchTabs: returnsSettingsTabs.map(({ key, label }) => ({
          href: getSettingsTabHref({
            href: returnsSettingsHref,
            param: RETURNS_SETTINGS_TAB_QUERY_PARAM,
            tab: key,
          }),
          id: key,
          label,
        })),
      }),
      navPage("returns-and-claims/assessments", {
        id: "assessments",
        href: routes.getSettingsSubRoute("assessments"),
        friendlyName: t("Assessments", {
          context: "merchant settings label for return assessments",
        }),
        UnfilledIcon: FileCheck02Icon,
        FilledIcon: FileCheck02FilledIcon,
      }),
      navPage("returns-and-claims/processing-groups", {
        id: "processing-groups",
        href: routes.getSettingsSubRoute("processing-groups"),
        friendlyName: t("Processing groups", {
          context: "merchant settings label for return processing groups",
        }),
        UnfilledIcon: LayoutGrid01Icon,
        FilledIcon: LayoutGrid01FilledIcon,
      }),
      navPage("returns-and-claims/post-processing", {
        id: "post-processing",
        href: routes.getSettingsSubRoute("post-processing"),
        friendlyName: t("Post processing", {
          context: "merchant settings label for post-return processing",
        }),
        UnfilledIcon: Route01Icon,
        FilledIcon: Route01FilledIcon,
      }),
      navPage("returns-and-claims/consolidation", {
        id: "consolidation",
        href: routes.getSettingsSubRoute("consolidation"),
        friendlyName: t("Consolidation", {
          context: "merchant settings label for return consolidation",
        }),
        UnfilledIcon: PackageIcon,
        FilledIcon: PackageFilledIcon,
      }),
      navPage("returns-and-claims/withdrawals", {
        id: "withdrawals",
        href: routes.getSettingsSubRoute("withdrawals"),
        friendlyName: t("Withdrawals", {
          context:
            "merchant settings label for customer statutory withdrawal-from-purchase requests, equivalent to the legal right of withdrawal, not cash or inventory withdrawals",
        }),
        UnfilledIcon: XCircleIcon,
        FilledIcon: XCircleFilledIcon,
      }),
    ],
  );
}

function useWarrantiesSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(
    visibility,
    "warranties",
    SettingsSectionEnum.WARRANTIES,
    [
      navPage("warranties/registration", {
        id: "registration-settings",
        href: routes.getSettingsSubRoute("registrations"),
        friendlyName: t("Registration", {
          context: "merchant settings label for warranty registration",
        }),
        UnfilledIcon: Pencil01Icon,
        FilledIcon: Pencil01FilledIcon,
      }),
      navPage("warranties/registration-rewards", {
        id: "warranty-registration-button",
        href: routes.getSettingsSubRoute("registration-rewards"),
        friendlyName: t("Registration rewards", {
          context: "merchant settings label for warranty registration rewards",
        }),
        UnfilledIcon: Award01Icon,
        FilledIcon: Award01FilledIcon,
      }),
    ],
  );
}

function useInternationalSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(
    visibility,
    "international",
    SettingsSectionEnum.INTERNATIONAL,
    [
      navPage("international/returns", {
        id: "international-returns",
        href: routes.getSettingsSubRoute("international/returns"),
        friendlyName: t("International returns", {
          context: "merchant settings label for international returns",
        }),
        UnfilledIcon: FlipBackwardIcon,
        FilledIcon: FlipBackwardFilledIcon,
      }),
    ],
  );
}

function useSupportSettings(
  visibility: SettingsVisibility,
): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  return settingsSection(visibility, "support", SettingsSectionEnum.SUPPORT, [
    navPage("support/general", {
      id: "support-general",
      href: routes.getSettingsSubRoute("general"),
      friendlyName: t("General", {
        context:
          "merchant settings label for general customer support configuration",
      }),
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    }),
    navPage("support/customer-widget", {
      id: "customer-widget-button",
      href: routes.getSettingsSubRoute("customer-widget"),
      friendlyName: t("Customer widget", {
        context: "merchant settings label for the customer widget",
      }),
      UnfilledIcon: MessageChatCircleIcon,
      FilledIcon: MessageChatCircleFilledIcon,
      searchTabs: getCustomerWidgetSearchTabs(
        routes.getSettingsSubRoute("customer-widget"),
      ),
    }),
    navPage("support/channels", {
      id: "support-channels",
      href: routes.getSettingsSubRoute("channels"),
      friendlyName: t("Channels", {
        context: "merchant settings label for customer support channels",
      }),
      UnfilledIcon: Inbox01Icon,
      FilledIcon: Inbox01FilledIcon,
    }),
    navPage("support/tags", {
      id: "support-tags",
      href: routes.getSettingsSubRoute(`${"tags"}`),
      friendlyName: t("Tags", {
        context: "merchant settings label for customer support tags",
      }),
      UnfilledIcon: Tag01Icon,
      FilledIcon: Tag01FilledIcon,
    }),
    navPage("support/macros", {
      id: "support-macros",
      href: routes.getSettingsSubRoute("macros"),
      friendlyName: t("Macros", {
        context: "merchant settings label for customer support macros",
      }),
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    }),
    navPage("support/topics", {
      id: "support-topics",
      href: routes.getSettingsSubRoute("topics"),
      friendlyName: t("Topics", {
        context: "merchant settings label for customer support topics",
      }),
      UnfilledIcon: MessageSquare01Icon,
      FilledIcon: MessageSquare01FilledIcon,
    }),
    navPage("support/rules", {
      id: "support-rules",
      href: routes.getSettingsSubRoute("rules"),
      friendlyName: t("Rules", {
        context: "merchant settings label for customer support rules",
      }),
      UnfilledIcon: FilterLinesIcon,
      FilledIcon: FilterLinesFilledIcon,
    }),
  ]);
}

function getCustomerWidgetSearchTabs(href: string): SettingItemSearchTab[] {
  return Object.values(CustomerWidgetTab).map((tab) => ({
    href: getSettingsTabHref({ href, param: CUSTOMER_WIDGET_TAB_QUERY, tab }),
    id: tab,
    label: customerWidgetTabToFriendly(tab),
  }));
}
